import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  perfReviewList: {
    requesting: false,
    items: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: {},
  },
  perfReviewDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
    updateSuccess: false,
  },
  pendingPerfReviewList: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },
}

export const perfReviewSlice = createSlice({
  name: 'performanceReview',
  initialState,
  reducers: {
    getPerfReviewList: (state, action) => {
      state.perfReviewList.requesting = true
      state.perfReviewList.error = null
      state.perfReviewList.items = []
      state.perfReviewList.success = false
      state.perfReviewList.filters = action.payload
    },
    getPerfReviewListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.perfReviewList.requesting = false
      state.perfReviewList.items = data
      state.perfReviewList.success = true
      state.perfReviewList.pagination.current_page = current_page
      state.perfReviewList.pagination.per_page = per_page
      state.perfReviewList.pagination.total = total
    },
    getPerfReviewListFail: (state, action) => {
      state.perfReviewList.requesting = false
      state.perfReviewList.error = action.payload
    },
    getPerfReviewDetails: (state) => {
      state.perfReviewDetails.requesting = true
      state.perfReviewDetails.error = null
      state.perfReviewDetails.data = null
      state.perfReviewDetails.success = false
      state.perfReviewDetails.updateSuccess = false;
    },
    getPerfReviewDetailsSuccess: (state, action) => {
      state.perfReviewDetails.requesting = false
      state.perfReviewDetails.data = action.payload
      state.perfReviewDetails.success = true
    },
    getPerfReviewDetailsFail: (state, action) => {
      state.perfReviewDetails.requesting = false
      state.perfReviewDetails.error = action.payload
    },
    doPerfReviewCreate: (state) => {
      state.perfReviewDetails.requesting = true
      state.perfReviewDetails.error = null
      state.perfReviewDetails.data = null
      state.perfReviewDetails.success = false
    },
    doPerfReviewCreateSuccess: (state, action) => {
      state.perfReviewDetails.requesting = false;
      state.perfReviewDetails.data = action.payload;
      state.perfReviewDetails.success = true;
    },
    doPerfReviewCreateFail: (state, action) => {
      state.perfReviewDetails.requesting = false;
      state.perfReviewDetails.error = action.payload;
      state.perfReviewDetails.success = false;
    },
    doPerfReviewUpdate: (state) => {
      state.perfReviewDetails.requesting = true
      state.perfReviewDetails.error = null
      state.perfReviewDetails.data = null
      state.perfReviewDetails.success = false
      state.perfReviewDetails.updateSuccess = false;
    },
    doPerfReviewUpdateSuccess: (state, action) => {
      state.perfReviewDetails.requesting = false;
      state.perfReviewDetails.data = action.payload;
      state.perfReviewDetails.success = true;
      state.perfReviewDetails.updateSuccess = true;
    },
    doPerfReviewUpdateFail: (state, action) => {
      state.perfReviewDetails.requesting = false;
      state.perfReviewDetails.error = action.payload;
      state.perfReviewDetails.success = false;
    },
    doPerfReviewDelete: (state) => {
      state.perfReviewDetails.requesting = true
      state.perfReviewDetails.error = null
      state.perfReviewDetails.data = null
      state.perfReviewDetails.success = false
    },

    getPendingPerfReviewList: (state, action) => {
      state.pendingPerfReviewList.requesting = true
      state.pendingPerfReviewList.error = null
      state.pendingPerfReviewList.items = []
      state.pendingPerfReviewList.success = false
      state.pendingPerfReviewList.filters = action.payload
    },
    getPendingPerfReviewListSuccess: (state, action) => {
      state.pendingPerfReviewList.requesting = false
      state.pendingPerfReviewList.items = action.payload
      state.pendingPerfReviewList.success = true
    },
    getPendingPerfReviewListFail: (state, action) => {
      state.pendingPerfReviewList.requesting = false
      state.pendingPerfReviewList.error = action.payload
    },

    
  },
})

export const {
  getPerfReviewList, getPerfReviewListSuccess, getPerfReviewListFail, 
  getPerfReviewDetails, getPerfReviewDetailsSuccess, getPerfReviewDetailsFail, 
  doPerfReviewCreate, doPerfReviewUpdate, doPerfReviewDelete,
  getPendingPerfReviewList, getPendingPerfReviewListSuccess, getPendingPerfReviewListFail,
  doPerfReviewUpdateSuccess
} = perfReviewSlice.actions

export default perfReviewSlice.reducer
